import React, {Component} from 'react';
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs';
import MainLayout from '../CommonControlls/MainLayout';
import Topmenu from '../CommonControlls/Topmenubar';
import {connect} from 'react-redux'
import {Link} from 'react-router-dom';
import {SelectDistrict, SelectAllProvince, SelectCompleteDistrictsList} from '../OfflineDb/IndexDbTranscSP'
import AlertModal from '../CommonControlls/AlertModal';
import {SyncConfig} from '../OfflineDb/ConfigDataSync'
import DropDown from '../CommonControlls/DropdownRendrer'
import SubRecipient_List from "./SubRecipient_List";


const mapStateToProps = (store) => {
    return store
}

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => {
            dispatch({type: "UpdateAlert", payload: Settings})
        },
        ShowLoader: (Isloading) => {
            dispatch({type: "UpdateLoader", payload: Isloading})
        },
    }
}

class SubRecipient_Add extends Component {

    constructor(props) {
        super(props);
        this.state = {

            Id: 0,

            alertModalData: {
                title: "",
                message: "",
                First_Callback: () => {
                },
                Second_Callback: () => {
                },
                type: 1,
            },

            ProvinceLoader: false,
            Provincelist: [],
            ProvinceId: 0,

            DistrictLoader: false,
            Districtlist: [],
            FilteredDistrictlist: [],
            DistrictId: 0,
        };
    }

    HandleAutoSuggestValChange = (fieldId, value) => {
        this.setState({[fieldId]: value})
    }

    render() {

        return (

            <div>
                <AlertModal  {...this.state.alertModalData} />
                <MainLayout/>
                <div id="right-panel" class="right-panel">
                    <Topmenu PageTitle={this.state.Id === 0 ? "Add Sub Recipient" : "Edit Sub Recipient"}
                             isShowAddBtn={false}/>
                    <div class="content">

                        <div class="card col-lg-5 col-md-5 col-sm-12 col-xs-12">
                            <div class="card-body row">
                                <form onSubmit={this.SubmitForm} novalidate>

                                    <div class="row">
                                        <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label for=""><span style={{color: "red"}}>* </span>Province</label>
                                            <DropDown
                                                multi={false}
                                                dropdownRenderer={false}
                                                create={false}
                                                onChange={this.HandleAutoSuggestValChange}
                                                Type="ProvinceId"
                                                options={this.state.Provincelist}
                                                val={this.state.ProvinceId}
                                                addPlaceholder=""
                                                disabled={false}
                                                loading={this.state.ProvinceLoader}
                                                searchBy="name"
                                                labelField="name"
                                                valueField="id"
                                                contentRenderer={false}
                                                placeholder="Select"
                                            />
                                        </div>

                                        {/*<div className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">*/}
                                        {/*    <label htmlFor=""><span style={{color: "red"}}>* </span>District</label>*/}
                                        {/*    <DropDown*/}
                                        {/*        multi={false}*/}
                                        {/*        dropdownRenderer={false}*/}
                                        {/*        create={false}*/}
                                        {/*        onChange={this.HandleAutoSuggestValChange}*/}
                                        {/*        Type="DistrictId"*/}
                                        {/*        options={this.state.Districtlist}*/}
                                        {/*        val={this.state.DistrictId}*/}
                                        {/*        addPlaceholder=""*/}
                                        {/*        disabled={false}*/}
                                        {/*        loading={this.state.DistrictLoader}*/}
                                        {/*        searchBy="name"*/}
                                        {/*        labelField="name"*/}
                                        {/*        valueField="id"*/}
                                        {/*        contentRenderer={false}*/}
                                        {/*        placeholder="Select"*/}
                                        {/*    />*/}
                                        {/*</div>*/}

                                        <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label for=""><span style={{color: "red"}}>* </span>Complete Name</label>
                                            <input autocomplete="off" type="text" class="form-control" id="CompleteName"
                                                   placeholder="Enter complete name" required/>
                                        </div>

                                        <div className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label htmlFor=""><span style={{color: "red"}}>* </span>Short
                                                Name</label>
                                            <input autoComplete="off" type="text" className="form-control"
                                                   id="ShortName" placeholder="Enter short name" required/>
                                        </div>

                                        <div
                                            class="form_footer formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <button type="submit" id="Form_SaveBtn" class="btn btn_style1">Save</button>
                                            {/*<button type="button" id="Form_DeleteBtn" onClick={this.onDelete}*/}
                                            {/*        hidden={this.state.Id === 0} class="btn btn_style2">Delete*/}
                                            {/*</button>*/}
                                            <Link to="/SubRecipient_List">
                                                <button type="button" id="Form_CancelBtn"
                                                        class="btn btn_style3">Cancel
                                                </button>
                                            </Link>

                                            {/* Hide button for reset */}
                                            <Link style={{display: "none"}} to="/SubRecipient_Add">
                                                <button id="Form_ResetBtn" type="button"
                                                        class="btn initial-btn Cancel-Form-btn Form_Btn">Reset
                                                </button>
                                            </Link>

                                        </div>

                                    </div>


                                </form>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        )
    }

    componentWillMount() {
        if (this.props.UserAuthentication.AuthToken === "") {
            this.props.history.push("/Login")
        }
    }

    componentDidMount() {
        Common.AddClassToMenueLink("MenuLink_Sr", true, "MenuParentLink_Geography")
        // Common.AddClassToMenueLink("MenuLink_Districts")

        this.GetPageConfigData(() => {
            var Id = Common.GetId()
            if (Id !== 0) {
                this.SelectSubRecipient(Id)
            }
        })

    }

    GetPageConfigData = (CallBack) => {
        this.props.ShowLoader({Isloading: true})
        var d1 = $.Deferred();
        var d2 = $.Deferred();
        this.SelectProvinces(() => {
            d1.resolve()
        })
        this.SelectDistricts(() => {
            d2.resolve()
        })
        $.when(d1, d2).done(() => {
            this.props.ShowLoader({Isloading: false})
            CallBack()
        });
    }
    SelectProvinces = (Callback) => {
        this.setState({ProvinceLoader: true})
        Common.Ajax(this.props.UserAuthentication.AuthToken, 'GET', false, Common.APILinks.SelectAll_Province, {}, (data) => {
            this.setState({
                ProvinceLoader: false,
                Provincelist: data.data
            })
            Callback()
        }, (error) => {
            this.setState({ProvinceLoader: false})
            this.props.ShowAlert({Type: 0, Msg: error})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
            Callback()
        })
    }
    SelectDistricts = (Callback) => {
        this.setState({DistrictLoader: true})
        Common.Ajax(this.props.UserAuthentication.AuthToken, 'GET', false, Common.APILinks.SelectAll_District, {}, (data) => {
            this.setState({
                DistrictLoader: false,
                Districtlist: data.data
            })
            Callback()
        }, (error) => {
            this.setState({DistrictLoader: false})
            this.props.ShowAlert({Type: 0, Msg: error})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
            Callback()
        })
    }
    LoadDataInEditMode = (data) => {
        this.setState({
            Id: data.id,
            ProvinceId: data.provinceId
        })
        $("#DistrictName").val(data.name)
    }
    ResetForm = () => {
        this.setState({
            Id: 0,
            ProvinceId: 0,
        })
        $("#CompleteName").val("")
        $("#ShortName").val("")
    }
    SubmitForm = (e) => {
        e.preventDefault()
        if (this.state.ProvinceId === 0) {
            this.props.ShowAlert({Type: 0, Msg: "Please select province"})
            setTimeout(() => {
                $("#Alertmsgbtn").click()
            }, 50);
            return
        }

        this.props.ShowLoader({Isloading: true})

        var Parameters = {
            id: this.state.Id,
            complete_name: $('#CompleteName').val(),
            short_name: $("#ShortName").val(),
            provinceid: this.state.ProvinceId,
            // districtid: this.state.DistrictId
        }
        Common.Ajax(this.props.UserAuthentication.AuthToken, "Post", false,
            this.state.Id === 0 ? Common.APILinks.Save_SubRecipient : Common.APILinks.Update_SubRecipient, JSON.stringify(Parameters), (resp) => {
                if (resp.status) {
                    this.props.ShowAlert({Type: 1, Msg: "Saved Successfully"})
                    setTimeout(function () {
                        $("#Alertmsgbtn").click()
                    }, 50);
                    this.props.ShowLoader({Isloading: false})
                    if (this.state.Id === 0)
                        this.ResetForm()
                    $("#RoleName").focus()
                    this.props.history.push('/SubRecipient_List')
                } else {
                    this.props.ShowLoader({Isloading: false})
                    this.props.ShowAlert({Type: 0, Msg: resp.message})
                    setTimeout(() => {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({Isloading: false})
                this.props.ShowAlert({Type: 0, Msg: "Something went wrong, please try again."})
                setTimeout(() => {
                    $("#Alertmsgbtn").click()
                }, 50);
            })

    }

    SelectSubRecipient = (id) => {
        Common.Ajax(this.props.UserAuthentication.AuthToken, 'GET', false, Common.APILinks.SelectALl_SubRecipient, {}, (resp) => {
            if(resp.status) {
                const sub = resp.data.find(s => s.id === id)
                this.setState({
                    Id: sub.id,
                    ProvinceId: sub.provinceid,
                    DistrictId: sub.districtid
                })
                $('#CompleteName').val(sub.complete_name)
                $('#ShortName').val(sub.short_name)
            }
        })
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(SubRecipient_Add);
